import { Button } from '@ntconsult/aluma-react';
import { type ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TITULO_PASSO } from './passo.types';

type Props = {
  titulo: ReactNode;
  subtitulo?: ReactNode;
  children: ReactNode;
  /** Ausente no 1º passo. */
  onVoltar?: () => void;
  /** Só quando o passo tem campos ou já tem resposta (R1, R3). */
  onContinuar?: () => void;
  /** No último passo, o Enviar (`type="submit"`) no lugar do Continuar. */
  acao?: ReactNode;
};

/** Um passo do formulário (spec 33 R1). Remontado a cada passo (`key`): o título recebe o foco. */
export function CartaoPasso({ titulo, subtitulo, children, onVoltar, onContinuar, acao }: Props) {
  const { t } = useTranslation('formulario');
  const focar = useCallback(
    (el: HTMLHeadingElement | null) => el?.focus({ preventScroll: true }),
    [],
  );
  return (
    <section className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <h2
          id={TITULO_PASSO}
          ref={focar}
          tabIndex={-1}
          className="text-lg font-semibold text-foreground outline-none"
        >
          {titulo}
        </h2>
        {subtitulo}
      </div>
      {children}
      {(onVoltar || onContinuar || acao) && (
        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
          {onVoltar ? (
            <Button type="button" variant="secondary" onClick={onVoltar}>
              {t('passos.voltar')}
            </Button>
          ) : (
            <span />
          )}
          {acao ??
            (onContinuar && (
              <Button type="button" variant="primary" onClick={onContinuar}>
                {t('passos.continuar')}
              </Button>
            ))}
        </div>
      )}
    </section>
  );
}
